import FinanceFundControl from "./FinanceFundControl";

/**
 * Fund Control must not expose the Settlement operator UI.
 * Settlement has its own canonical page at /finance/settlement.
 *
 * Keep the legacy Fund Control implementation intact for its remaining
 * Wallet/Adjustment/Opening workflows. The duplicate settlement panel is
 * hidden structurally by the existing finance-fund-control-cleanup.css rule,
 * so this wrapper must not mutate React-managed DOM nodes.
 */
export default function FinanceFundControlClean() {
  return <FinanceFundControl />;
}
